import React from 'react';

import classes from './style.module.scss';

export type MainContentComponent = React.FC

const MainContent: MainContentComponent = ({ children }) => <div className={classes['main-content']} id="main-scrollable-wrapper">{children}</div>;

export default MainContent
